<template>
    <div>
        <headertermsandConditions />
        <div
            class="px-[10px] tablet:px-[20px] desktop:px-[40px] pb-[100px] pt-[115px] tablet:pt-[110px] laptop:pt-[80px] largeDesktop:pt-[120px]">
            <h4 class="tablet:text-[20px] laptop:text-[24px] font-semibold font-poppins text-center text-[#333333]">
                Privacy Policy</h4>
            <div class="contractoragreementPg min-h-screen pt-[20px] w-full pb-[20px] mt-[20px] font-poppins terms-condition-page !bg-white px-[15px] tablet:px-[20px] shadow-custom rounded-[10px] relative z-10"
                v-html="cleanHtml" ref="contentContainer">
            </div>
        </div>
        <div
            class="!absolute bottom-0 left-0 w-full text-center shadow-lg rounded-t-full z-10 flex items-center h-[40px] laptop:h-[50px] justify-center mt-4 mobile:pr-[30px] bg-customBlue-100">
            <p class="select-none tablet:mb-0 mobile:!mb-0 text-white mobile:text-[12px] laptop:text-sm font-roboto">
                Copyright © 2025 MyHappyHome | <a href="/contact-us" class="text-customYellow-100">Contact Us</a>
            </p>
        </div>
    </div>
</template>

<script>
import headertermsandConditions from "../../components/layouts/header/terms-and-conditions-header.vue";
import { mapActions, mapGetters } from "vuex";

export default {
    components: {
        headertermsandConditions,
    },
    data() {
        return {
            cleanHtml: "",
        };
    },
    computed: {
        ...mapGetters(["updatePrivacyPolicyDetails"]),
    },
    watch: {
        "updatePrivacyPolicyDetails.terms_and_conditions_text": {
            handler(newVal) {
                if (!newVal) return;

                // Extract only body content
                const parser = new DOMParser();
                const doc = parser.parseFromString(newVal, "text/html");
                this.cleanHtml = doc.body.innerHTML;

                this.$nextTick(() => {
                    this.enableAnchorScrolling();
                });
            },
            immediate: true,
        },
    },
    mounted() {
        this.getPrivacyPolicyDetails();
    },
    methods: {
        ...mapActions(["getPrivacyPolicyDetails"]),

        enableAnchorScrolling() {
            const container = this.$refs.contentContainer;
            if (!container) return;

            const links = container.querySelectorAll('a[href^="#"]');
            links.forEach((link) => {
                // Remove old listener
                link.removeEventListener("click", link._anchorHandler);

                link._anchorHandler = (e) => {
                    e.preventDefault();

                    const hash = link.getAttribute("href");
                    const target = document.getElementById(hash.replace("#", ""));
                    if (!target) return;

                    // Scroll relative to container
                    const topOffset = target.getBoundingClientRect().top + window.scrollY;

                    // Optional: adjust for fixed header, e.g. 80px
                    const headerOffset = 0;

                    window.scrollTo({
                        top: topOffset - headerOffset,
                        behavior: "smooth",
                    });
                };

                link.addEventListener("click", link._anchorHandler);
            });
        },
    },
};
</script>
